<template>
  <div class="weather-widget">
    <div class="weather-header">
      <slot name="title"><h3>{{ city }}</h3></slot>
      <hr />
    </div>

    <div v-if="weatherData" class="weather-content">
      <img
        :src="`https://openweathermap.org/img/wn/${weatherData.current.weather[0].icon}@2x.png`"
        alt="Weather icon"
        class="weather-icon"
      />
      <div class="weather-info">
        <p class="description">{{ weatherData.current.weather[0].description }}</p>
        <h2 style="margin-top: 15px;"><b>{{ formatTemp(weatherData.current.temp) }}°C</b></h2>
        <p style="margin-top: 15px;">Humidade: <b>{{ weatherData.current.humidity }}%</b></p>
      </div>
    </div>

    <div v-else class="weather-loading">
      <img src="https://openweathermap.org/img/wn/02d@2x.png" class="weather-icon" />
      <span class="loading-text">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Weather3',
  props: {
    apiKey: String,
    city: String,
    latitude: Number,
    longitude: Number,
    language: { type: String, default: 'pt' },
    units: { type: String, default: 'metric' }
  },
  data() {
    return {
      weatherData: null
    }
  },
  mounted() {
    this.fetchWeather()
  },
  methods: {
    async fetchWeather() {
      const url = `https://api.openweathermap.org/data/3.0/onecall?lat=${this.latitude}&lon=${this.longitude}&appid=${this.apiKey}&units=${this.units}&lang=${this.language}`;
      try {
        const res = await fetch(url);
        this.weatherData = await res.json();
      } catch (err) {
        console.error('Erro ao buscar dados do tempo:', err);
      }
    },
    formatTemp(value) {
      return value.toFixed(1);
    }
  }
}
</script>

<style scoped>
.weather-widget {
  text-align: center;
  font-family: Arial, sans-serif;
}

.weather-header {
  font-weight: bold;
  margin-bottom: 0.5em;
}

.weather-header hr {
  border: none;
  border-bottom: 1px solid #333;
  width: 100%;
  margin: 0.25em auto 1em;
}

.weather-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.weather-icon {
  width: 80px;
  height: 80px;
}

.weather-info p {
  margin: 0.25em 0;
}

.weather-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #333;
}

.loading-text {
  font-weight: 500;
  margin-top: -10px;
}
</style>
